/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Article from 'flarum/orell-articles/models/Article';
import Bookshelf from '../common/models/Bookshelf';
import Note from '../common/models/Note';
import Status from '../common/models/Status';
import UserArticleStatus from '../common/models/UserArticleStatus';

export default [
	new Extend.Store() //
		.add('bookshelves', Bookshelf)
		.add('book_status', Status)
		.add('user_article_status', UserArticleStatus)
		.add('book_notes', Note),

	new Extend.Model(User) //
		.hasMany<Bookshelf>('bookshelves')
		.attribute<number>('bookshelfCount')
		.attribute<boolean>('canCreateBookshelves'),

	new Extend.Model(Article) //
		.hasOne<Bookshelf>('bookshelf')
		.hasOne<UserArticleStatus>('userStatus')
		.hasOne<Note>('note'),
];
